import React from 'react';
import { Dimmer, Segment } from 'semantic-ui-react';
import './Loading.css';
import { ReactComponent as SailboatImage } from '../AddABoat/images/catamaran.svg';

const Loading = () => (
  <Segment style={{ minHeight: '200px', border: 'none', boxShadow: 'none', marginTop: '10%' }}>
    <Dimmer active inverted>
      <div className="custom-loader">
        <SailboatImage className="sailboat-image" />
      </div>
    </Dimmer>
  </Segment>
);

export default Loading;
